<ng-container *ngIf="model && model.view && layoutMode !== 'gallery'">
  <div
    data-cy="go-links-item"
    class="go-link-item"
    [ngClass]="{ 'go-link-result-line': showResultSections.showResultSections, clickable: isClickable }"
    tabindex="-1"
  >
    <u-icon
      data-cy="go-links-item-icon"
      class="go-link-icon"
      [model]="{ type: 'img', value: iconValue }"
      [inSvg]="model.view?.icon?.lightUrl"
      [inSvgIgnoreColors]="['#BE8DF6']"
      [fallback]="GO_LINK_ICON_FALLBACK"
      [styles]="showResultSections.showResultSections ? { width: '20px', height: '20px' } : { width: '24px', height: '24px' }"
    ></u-icon>
    <div class="main" #main>
      <div class="go-link-header">
        <result-title
          [model]="model.view.title"
          [highlights]="model?.highlights"
          [selected]="selected"
          click-invoker
          #title
          (invoke)="
            onInvoke({
              command: $event.command,
              context: makeContext({ appId: 'go-links' }, $event.context),
              trigger: $event.trigger,
              immediate: $event.immediate,
            })
          "
        >
        </result-title>
        <div class="badges" *ngIf="model.view.badges?.length && !showResultSections.showResultSections">
          <ng-container *ngTemplateOutlet="badges"></ng-container>
        </div>
        <ng-template #badges>
          <div *ngFor="let badge of model.view.badges">
            <result-badge data-cy="go-links-item-badge" [model]="badge"></result-badge>
          </div>
        </ng-template>
        <ng-container  *featureFlagEnabled="DISABLED_FAVORITES_WORKSPACE_FEATURE_FLAG">
          <div class="favorite" *ngIf="model.isFavorite && showResultSections.showFavoriteIcon">
            <u-icon class="icon" [model]="{ type: 'font', value: 'icon-star-solid' }"></u-icon>
          </div>
        </ng-container>
      </div>
      <div class="go-link-description">
        <result-subtitle
          *ngIf="model.view.subtitle?.text && (!showResultSections.showResultSections || showResultSections.showSubtitle)"
          [model]="model.view.subtitle"
          [highlights]="model?.highlights"
          #subtitle
        >
        </result-subtitle>
      </div>
      <div *ngIf="model.view.badge && showResultSections.showBadge">
        <ng-container *ngTemplateOutlet="unlisted"></ng-container>
      </div>
      <div class="go-links-bullets" tabindex="-1" *ngIf="model.view?.bullets?.length > 0">
        <div class="go-links-bullets-content">
          <div class="bullets" *ngIf="!showResultSections.showResultSections && showResultSections.showBullets">
            <ng-container *ngFor="let bullet of model.view.bullets | slice: 0 : bulletsLimit; index as i">
              <result-bullet
                #resultBullet
                data-cy="result-bullet-container"
                *ngIf="i !== 0 || previewState !== 'side'"
                tabindex="-1"
                [model]="bullet.parts.length ? bullet : undefined"
                [highlights]="bullet.text?.startsWith('http') ? model?.highlights : []"
                [fallback]="MEMBER_ICON_FALLBACK"
                [ngStyle]="i === bulletsLimit - 1 ? { 'max-width': lastChildWidth + 'px' } : { 'max-width': '100%' }"
                (click)="$event.stopPropagation()"
              >
              </result-bullet>
            </ng-container>
            <result-bullet
              *ngIf="model?.view?.bullets?.length - bulletsLimit > 0 && !isExtension"
              tabindex="-1"
              [model]="counterBullet"
              click-invoker
              (invoke)="onMouseClick({ command: $event })"
            ></result-bullet>
          </div>
          @if (!showResultSections.showResultSections && showResultSections.showAvatarList && !isExtension) {
            <div class="go-links-avatar-list">
              @if (avatarsList.length > 0) {
                <div class="divider-container">
                  <span class="bullet-divider"></span>
                </div>
                <span (mouseover)="viewsTooltip.show($event)" (mouseleave)="viewsTooltip.hide()">{{ model.visit?.count }} views</span>
              }
            </div>
          }
        </div>
      </div>
      <div data-cy="go-links-item-tags" class="go-links-tags" *ngIf="!showResultSections.showResultSections && showResultSections.showTags">
        <div class="tag-group" *ngFor="let group of model.view.tagGroups">
          <result-tag data-cy="go-links-item-tags-item" *ngFor="let tag of group.tags" [model]="tag"> </result-tag>
        </div>
      </div>
    </div>
    <div class="buttons-container" *ngIf="!showResultSections.showResultSections">
      <div class="favorite-star" (click)="toggleFavorite('mouse_click')" click-invoker *ngIf="showResultSections.showFavoriteAction">
        <u-icon
          pTooltip="Remove from favorites"
          tooltipPosition="top"
          tooltipStyleClass="u-tooltip"
          [styles]="{ color: 'var(--purple-500)', fontSize: '14px' }"
          [model]="{ type: 'font', value: 'icon-star-solid' }"
        ></u-icon>
      </div>
      <square-button
        *ngIf="showResultSections?.showContextMenu"
        data-cy="go-links-item-action-kebab"
        [active]="contextMenuHelper?.source === 'actions'"
        click-invoker
        (click)="$event.stopPropagation(); openContextMenu($event, 'actions')"
        (auxclick)="$event.stopPropagation(); openContextMenu($event, 'actions')"
        (contextmenu)="$event.stopPropagation(); openContextMenu($event, 'actions')"
        #actions
        >•••</square-button
      >
      <new-indication *ngIf="showResultSections?.showNewIndication" [tooltip]="showResultSections.showNewIndication"></new-indication>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="layoutMode === 'gallery'">
  <gallery-view
    [model]="model"
    [settings]="{
      showCheckbox: showResultSections.isEditable,
      showFavorite: model.isFavorite && showResultSections.showFavoriteIcon,
      showDrag: showResultSections.isDraggable,
      showNewIndication: showResultSections?.showNewIndication,
    }"
    [contextMenuActive]="contextMenuHelper?.source === 'actions'"
    (invoke)="galleryInvoke($event)"
    [checked]="checked"
    [selected]="selected"
  >
    <ng-template let-value pTemplate="dragItem">
      <ng-content select=".drag-ind"></ng-content>
    </ng-template>
  </gallery-view>
</ng-container>

<p-overlayPanel #viewsTooltip [showTransitionOptions]="'0.1.5s'" [hideTransitionOptions]="'0ms'">
  <avatar-list-tooltip
    [items]="(avatarsList || []).slice(0, VIEWS_TOOLTIP_LIMIT)"
    [sizeAvatarTooltip]="'16px'"
    [header]="'LAST VIEWED BY'"
    [footer]="avatarsList?.length - VIEWS_TOOLTIP_LIMIT > 0 ? '+ ' + (avatarsList?.length - VIEWS_TOOLTIP_LIMIT) + ' more views' : null"
  ></avatar-list-tooltip>
</p-overlayPanel>
